import React from 'react'
import { Con } from './contact.styled'


export default function Contact() {

  document.querySelector('title').innerText = 'Contact | Beehive Cafe'

  React.useEffect(()=>{
    const loader = document.querySelector('.loading')
    loader.style.display = 'none'
    return ()=>{
      loader.style.display = 'block'
    }
  })
  return (
    <div>
      <Con>
      <h1>Ask any question or enquiry you by filling in the following form</h1>
      <div className="form">
        <div> 
          <label htmlFor="">Firstname</label><br />
          <input placeholder='Francis' type="text" />
        </div>
        <div>
          <label htmlFor="">Lastname</label><br />
          <input placeholder='Ratalane' type="text" />
        </div>
        <div>
          <label htmlFor="">Email</label><br />
          <input placeholder='francisratalane@gmail.com' type="email" />
        </div>
        <div> 
          <label htmlFor="">Phone</label><br />
          <input placeholder='+27678525100' type="tel" />
        </div>
        <div> 
          <label htmlFor="">Message</label><br />
          <textarea name="" id="" cols="30" rows="10"></textarea>
        </div>
        <div className="submit">
          <button>Submit</button>
        </div>
        <iframe title='beehive' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3600.639675008557!2d28.056762315015856!3d-25.51706098374834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ebfcf3d9c81034b%3A0x48459ef151af2780!2sBeeHive%20Cafe!5e0!3m2!1sen!2sza!4v1660352680215!5m2!1sen!2sza" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      </Con>
    </div>
  )
}
